import React from "react";
import { StatusCode } from "storefront/pages/_error/StatusCode";

import styles from "storefront/components/FullPageError/FullPageError.module.scss";

type Props = { errorCode: StatusCode | "unknown" };

const ERROR_CONTENT: Record<
  StatusCode | "unknown",
  { title: string; message: string | null; imgAlt: string }
> = {
  "404": {
    title: "Page Not Found",
    message: null,
    imgAlt: "Hans looking sad because he can't find the page he's looking for.",
  },
  "500": {
    title: "Internal Server Error",
    message:
      "Sorry, we encountered a problem. Please email help@grailed.com if you need assistance.",
    imgAlt:
      "Hans looking sad because an error occurred in trying to load the page.",
  },
  unknown: {
    title: "Something went wrong",
    message: "Please refresh the page to try again.",
    imgAlt: "Hans looking sad because an error occurred in the page.",
  },
};

const FullPageError = ({ errorCode = "unknown" }: Props) => {
  const content = ERROR_CONTENT[errorCode];

  return (
    <div className={styles.errorPage}>
      <h2 className={styles.heading}>
        {errorCode !== "unknown" ? (
          <span className={styles.statusCode}>{errorCode}</span>
        ) : (
          <></>
        )}

        <span className={styles.title}>{content.title}</span>
      </h2>

      {content.message ? (
        <p className={styles.message}>{content.message}</p>
      ) : null}

      <img
        className={styles.image}
        src="https://assets.grailed.com/sad-hans.webp"
        alt={content.imgAlt}
      />
    </div>
  );
};

export default FullPageError;
